$(document).ready(function () {
    const storelocator22 = setInterval(storelocator, 1000);
    function storelocator() {
        $("li.stockist-result.stockist-list-result").each(function () {
            var data_html = $(this).find(".custom_data_wrapp").html();
            if (typeof data_html === "undefined") {
                $("<div class='custom_data_wrapp'></div>").insertAfter($(this).find(".stockist-result-name"));
                $($(this).find(".stockist-result-address")).appendTo($(this).find(".custom_data_wrapp"));
                $($(this).find(".stockist-result-custom-fields")).appendTo($(this).find(".custom_data_wrapp"));
                $("<div><strong>Address</strong></div>").insertBefore($(this).find(".stockist-result-addr-1"));
            } else {
            }
        });
    }
    // $(document).on("click", "li.stockist-result.stockist-list-result a", function (e) {
    //     e.preventDefault();
    //     var custom_url = $(this)
    //         .parents("li.stockist-result.stockist-list-result")
    //         .find(".stockist-result-details .stockist-result-website a")
    //         .attr("href");
    //     window.open(custom_url, "_blank");
    // });
    // $(document).on("click", ".stockist-result.stockist-map-result a", function (e) {
    //     e.preventDefault();
    //     var custom_url = $(this)
    //         .parents(".stockist-result.stockist-map-result")
    //         .find(".stockist-result-details .stockist-result-website a")
    //         .attr("href");
    //     window.open(custom_url, "_blank");
    //     setCookie("appointmentform", "appointmentform", 1);
    // });

    $(document).on("click", "li.stockist-result.stockist-list-result a:not([href^='tel:'])", function (e) {
    e.preventDefault();

    var custom_url = $(this)
        .parents("li.stockist-result.stockist-list-result")
        .find(".stockist-result-details .stockist-result-website a")
        .attr("href");

    window.open(custom_url, "_blank");
});

$(document).on("click", ".stockist-result.stockist-map-result a:not([href^='tel:'])", function (e) {
    e.preventDefault();

    var custom_url = $(this)
        .parents(".stockist-result.stockist-map-result")
        .find(".stockist-result-details .stockist-result-website a")
        .attr("href");

    window.open(custom_url, "_blank");
    setCookie("appointmentform", "appointmentform", 1);
});
});
